module.exports = __webpack_public_path__ + "img/translion.bb013331.jpg";